import React, { useState } from 'react';
import _ from 'lodash';
import OnlyStars from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Reviews/OnlyStars';
import FsLightbox from 'fslightbox-react';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { ProductReviewsReview } from '@progymedia/gatsby-theme-boutik-ecommerce/src/models/productReviews';
import { useOtherBoutikService } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Hooks/useOtherBoutikService';
import { ReviewsService } from '@progymedia/gatsby-theme-boutik-ecommerce/src/interfaces/services/reviewsService';

type ApplianceReviewProps = {
    review: ProductReviewsReview;
    reviewImgUrls: Record<string, string>;
};

export default function ApplianceReview(props: ApplianceReviewProps) {
    const { review, reviewImgUrls } = props;
    const [isLightBoxVisible, setIsLightBoxVisible] = useState(false);

    const reviewsService: ReviewsService =
        useOtherBoutikService('ReviewsService');
    const { currentLocale } = usePageLocalization();

    const reviewImage =
        reviewImgUrls[reviewsService.generateImageReviewId(review)];

    const date = new Date(
        review?.created_at?.substring(0, review?.created_at?.indexOf(' '))
    );
    const options = {
        month: 'long',
        year: 'numeric',
        day: 'numeric',
    } as any;

    return (
        <div className='review' key={review.created_at}>
            <div className='customer-info'>
                <span className='name'>{review?.nickname}</span>
                <span className='date'>
                    {date.toLocaleDateString(
                        currentLocale.replace('_', '-'),
                        options
                    )}
                </span>
            </div>
            <div className='review-info'>
                <span className='stars'>
                    <OnlyStars rating={review.rating} />
                </span>
                <div className='review-title'>{review?.summary}</div>
                <div className='review-description'>{review?.text}</div>
                {reviewImage && (
                    <>
                        <div className='review-image'>
                            <img
                                className='review-img'
                                src={reviewImage}
                                onClick={() => setIsLightBoxVisible(!isLightBoxVisible)}
                                alt=''
                            />
                        </div>
                        <FsLightbox toggler={isLightBoxVisible} sources={[reviewImage]} exitFullscreenOnClose={true} />
                    </>
                )}
            </div>
        </div>
    );
}
